import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowUpLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-up-left"} maskId="square-filled-radius-0-stroke-1-IconArrowUpLeft"><path fillRule="evenodd" clipRule="evenodd" d="M5 5H16V7H8.41421L19.1642 17.75L17.75 19.1642L7 8.41421V16H5V5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowUpLeft;
